import { WtpData } from './wtp-data';
import { BaseCountry } from './base-country';

export class WtpCountry extends BaseCountry {
  wtpData: WtpData [];
}
